<template>
    <aside class="rounded border border-neutral-700 bg-neutral-950 p-6 shadow-2xl shadow-black/30">
        <div class="flex items-center justify-between gap-4 mb-6">
            <div>
                <div class="text-sm font-semibold uppercase text-brand-primary-300 mb-1">
                    V3ME Pro
                </div>
                <div class="text-neutral-400 text-sm">
                    All tracking tools included
                </div>
            </div>
            <div class="rounded-sm border border-brand-primary-500 bg-brand-primary-950 px-3 py-1 text-sm font-semibold text-brand-primary-200">
                2 weeks free
            </div>
        </div>

        <div class="grid grid-cols-2 rounded border border-neutral-800 bg-black p-1 mb-8">
            <button
                type="button"
                class="rounded-sm px-4 py-3 text-sm font-semibold transition-colors"
                :class="interval === 'month' ? 'bg-brand-primary-400 text-white' : 'text-neutral-400 hover:text-white'"
                @click="interval = 'month'"
            >
                Monthly
            </button>
            <button
                type="button"
                class="rounded-sm px-4 py-3 text-sm font-semibold transition-colors"
                :class="interval === 'year' ? 'bg-brand-primary-400 text-white' : 'text-neutral-400 hover:text-white'"
                @click="interval = 'year'"
            >
                Yearly
            </button>
        </div>

        <div class="mb-6">
            <div class="flex items-end gap-2">
                <span class="text-5xl font-bold text-white">{{ price }}</span>
                <span class="pb-2 text-neutral-400">{{ period }}</span>
            </div>
            <div class="mt-3 text-sm text-brand-primary-300">
                {{ billingNote }}
            </div>
        </div>

        <button
            type="button"
            class="w-full rounded bg-brand-primary-400 px-6 py-4 text-center font-semibold text-white transition-colors hover:bg-brand-primary-300"
            @click="handleSignUpClick"
        >
            Start 2 Week Free Trial
        </button>

        <div class="mt-4 text-center text-sm text-neutral-500">
            No credit card required to start.
        </div>

        <div class="my-6 border-t border-neutral-800"></div>

        <div class="space-y-4">
            <div v-for="feature in features" :key="feature" class="flex items-start gap-3">
                <Icon icon="check" pack="fas" class="mt-1 text-brand-primary-400" />
                <span class="text-sm leading-relaxed text-neutral-300">{{ feature }}</span>
            </div>
        </div>

        <div class="mt-6 rounded border border-neutral-800 bg-black p-4 text-sm leading-relaxed text-neutral-400">
            Built for resistance band lifters who want previous bands, reps, notes, photos, and body metrics in one place.
        </div>
    </aside>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: 'Pricing',
    computed: {
        billingNote() {
            return this.interval === 'year'
                ? 'Save $20 compared with monthly billing.'
                : 'Simple monthly billing after the trial.';
        },
        period() {
            return this.interval === 'year' ? '/ year' : '/ month';
        },
        price() {
            return this.interval === 'year' ? '$100' : '$10';
        },
    },
    data() {
        return {
            interval: 'month',
            features: [
                'Workout, body, and custom logs',
                'Progress photos and analytics',
                'Custom movements, bands, and templates',
                'Phone, tablet, and desktop access',
            ],
        };
    },
    methods: {
        handleSignUpClick() {
          window.location = `${import.meta.env.VITE_VUE_APP_URL}/auth/sign-up`;
        },
    }
})
</script>

<style scoped lang="scss">

</style>
